import { GetForecastForReceiptResponseResult } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage/api';
import { IForecastForReceiptList } from '../domains/entities/forecastForReceiptList';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 * 受領用内示取得のアダプタ
 */
export class GetForecastForReceiptAdapter {
  /**
   * responseをUI用に変換する
   * @param response - レスポンス
   */
  public static adaptForResponse(response: GetForecastForReceiptResponseResult): IForecastForReceiptList {
    return {
      forecastForReceipts: response.data.map((forecastForReceipt) => {
        return {
          forecastForReceiptId: forecastForReceipt.forecastForReceiptId,
          forecastForReceiptName: forecastForReceipt.forecastForReceiptName,
          forecastForReceiptResponsibleUsers:
            forecastForReceipt.forecastForReceiptResponsibleUsers?.map((user) =>
              UserAccountFactory.create({ email: user.id, name: user.name })
            ) ?? [],
          outputRange: forecastForReceipt.outputRange,
        };
      }),
      pagingOptions: {
        pageSize: response.data.length,
        offset: response.data.length,
        returnCount: response.data.length,
      },
    };
  }
}
